module.exports = __webpack_public_path__ + "img/battlestar.15b49974.webp";